import { createClientErrorReporter } from "../../../../../../shared/frontend/feedback/clientErrorReporterFactory";
import { loadAuthFromStorage } from "../auth/authStorage";

export { toReportableError } from "../../../../../../shared/frontend/feedback/clientErrorTypes";

function getClientErrorsUrl(): string {
  const apiBase = (import.meta.env.VITE_API_BASE_URL || "").trim().replace(/\/+$/, "") || "";
  return apiBase ? `${apiBase}/api/v1/client-errors` : "/api/v1/client-errors";
}

// m1member meldet sich per Bearer-Token an; Mandant und Benutzer ermittelt der Server daraus.
function buildHeaders(): Record<string, string> {
  const { token, info } = loadAuthFromStorage();
  const headers: Record<string, string> = {};
  if (token) headers.Authorization = `Bearer ${token}`;
  if (info?.tenantId) headers["X-Tenant-Id"] = info.tenantId;
  return headers;
}

export const postClientErrorOnce = createClientErrorReporter({ endpoint: getClientErrorsUrl(), buildHeaders });
